import { FileText, Mail, Phone, MapPin, Calendar } from 'lucide-react'

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="container-custom py-8">
          <div className="flex items-center mb-4">
            <FileText className="h-8 w-8 text-orange-500 mr-3" />
            <h1 className="text-3xl font-bold text-gray-900">Mentions légales</h1>
          </div>
          <p className="text-gray-600">
            Informations légales concernant Flightcase FWI
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="container-custom py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          
          {/* Informations de l'entreprise */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <FileText className="h-6 w-6 text-orange-500 mr-2" />
              Informations de l'entreprise
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Raison sociale :</h3>
                    <p className="text-gray-700">FLIGHTCASE FWI SASU</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <MapPin className="h-5 w-5 text-orange-500 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Adresse du siège social :</h3>
                    <p className="text-gray-700">HOTEL LA TOUBANA SECTION DURIVAGE, 97180 SAINTE-ANNE</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <Calendar className="h-5 w-5 text-orange-500 mt-1 flex-shrink-0" />
                  <div>
                    <h3 className="font-semibold text-gray-900">Date de création :</h3>
                    <p className="text-gray-700">20 mars 2020</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900">SIRET du siège social :</h3>
                    <p className="text-gray-700">882 469 174 00016</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Numéro de TVA :</h3>
                    <p className="text-gray-700">FR17882469174</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Activité (NAF / APE) :</h3>
                    <p className="text-gray-700">7739Z - Location et location-bail d'autres machines, équipements et biens matériels n.c.a.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Forme juridique :</h3>
                    <p className="text-gray-700">Société par actions simplifiée</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Directeur de publication :</h3>
                    <p className="text-gray-700">Kevin Desgalier</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Mail className="h-6 w-6 text-orange-500 mr-2" />
              Contact
            </h2>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-orange-500" />
                <div>
                  <h3 className="font-semibold text-gray-900">Email :</h3>
                  <p className="text-gray-700">contact@flightcasefwi.com</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-orange-500" />
                <div>
                  <h3 className="font-semibold text-gray-900">Téléphone :</h3>
                  <p className="text-gray-700">+590 590 26 54 30</p>
                </div>
              </div>
            </div>
          </section>

          {/* Hébergement */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Hébergement du site</h2>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-700 mb-4">
                Ce site est hébergé par IONOS.
              </p>
              <div className="space-y-2 text-gray-700">
                <div className="flex items-center space-x-2">
                  <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
                  <span>Hébergeur : IONOS</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
                  <span>Adresse : 1&1 IONOS SE, Elgendorfer Str. 57, 56410 Montabaur, Allemagne</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-1.5 h-1.5 bg-orange-500 rounded-full"></div>
                  <span>Développement : Laurent Cirany</span>
                </div>
              </div>
            </div>
          </section>

          {/* Propriété intellectuelle */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Propriété intellectuelle</h2>
            <div className="space-y-4 text-gray-700">
              <p>
                L'ensemble de ce site relève de la législation française et internationale 
                sur le droit d'auteur et la propriété intellectuelle. Tous les droits de 
                reproduction sont réservés, y compris pour les documents téléchargeables 
                et les représentations iconographiques et photographiques.
              </p>
              <p>
                La reproduction de tout ou partie de ce site sur un support électronique 
                quel qu'il soit est formellement interdite sauf autorisation expresse 
                du directeur de la publication.
              </p>
            </div>
          </section>

          {/* Protection des données */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Protection des données personnelles</h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD), 
                Flightcase FWI s'engage à protéger vos données personnelles.
              </p>
              <p>
                Les données collectées sur ce site sont utilisées exclusivement pour :
              </p>
              <ul className="ml-6 space-y-2">
                <li className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span>La gestion de vos commandes et réservations</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span>L'amélioration de nos services</span>
                </li>
                <li className="flex items-start space-x-2">
                  <div className="w-1.5 h-1.5 bg-orange-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span>La communication commerciale (avec votre accord)</span>
                </li>
              </ul>
              <p>
                Vous disposez d'un droit d'accès, de rectification, de suppression et 
                d'opposition concernant vos données personnelles. Pour exercer ces droits, 
                contactez-nous à : contact@flightcasefwi.com
              </p>
            </div>
          </section>

          {/* Cookies */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Cookies</h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Ce site utilise des cookies techniques nécessaires au bon fonctionnement 
                de l'application (authentification, panier, préférences utilisateur).
              </p>
              <p>
                Aucun cookie de tracking ou de publicité n'est utilisé. Les cookies 
                techniques ne nécessitent pas de consentement préalable.
              </p>
            </div>
          </section>

          {/* Responsabilité */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Limitation de responsabilité</h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Les informations contenues sur ce site sont aussi précises que possible 
                et le site remis à jour à différentes périodes de l'année, mais peut 
                toutefois contenir des inexactitudes ou des omissions.
              </p>
              <p>
                Si vous constatez une lacune, erreur ou ce qui parait être un dysfonctionnement, 
                merci de bien vouloir le signaler par email, à l'adresse contact@flightcasefwi.com, 
                en décrivant le problème de la manière la plus précise possible.
              </p>
            </div>
          </section>

          {/* Droit applicable */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">Droit applicable</h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Tout litige en relation avec l'utilisation du site flightcasefwi.com 
                est soumis au droit français. Il est fait attribution exclusive de 
                juridiction aux tribunaux compétents de Basse-Terre, Guadeloupe.
              </p>
            </div>
          </section>

          {/* Dernière mise à jour */}
          <section className="border-t pt-6">
            <div className="bg-orange-50 p-4 rounded-lg">
              <p className="text-sm text-orange-800">
                <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default MentionsLegales
